import React from 'react';

const SearchActionsBar = ({
  setQuery,
  setResults,
  setTotalCount,
  setTransparency,
  user,
  saveSearch
}) => {
  return (
    <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <button
        onClick={() => { setQuery(''); setResults([]); setTotalCount(0); setTransparency(null); }}
        style={{
          background: '#f5f5f5',
          color: '#333',
          padding: '8px 16px',
          borderRadius: '4px',
          border: '1px solid #ddd',
          cursor: 'pointer',
          fontWeight: '500'
        }}
      >
        New Search
      </button>
      <div style={{ display: 'flex', gap: '8px' }}>
        {user && (
          <button
            onClick={saveSearch}
            style={{
              background: '#545f6b',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '4px',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Save This Search
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchActionsBar;